<lib-chart
    class="chart"
    [type]="'radialChart'"
    [options]="options"
    [checkHostResize]="true"
>
</lib-chart>
